import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LaunchpadUser } from '../../models/launchpad-user';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ClaimKeys } from '../../../constants/claim-keys';

@Component({
    selector: 'app-user-data-grid',
    templateUrl: './user-data-grid.component.html',
    styleUrls: ['./user-data-grid.component.sass'],
    standalone: false
})
export class UserDataGridComponent implements OnInit {
  @Input() users: LaunchpadUser[] = [];
  @Input() loading: boolean = true;
  @Input() searchTerm: string = '';
  @Input() hasImpersonatorRole: boolean = false;
  @Input() readOnly: boolean = false;

  @Output() editUserClicked: EventEmitter<LaunchpadUser> = new EventEmitter<LaunchpadUser>();
  @Output() detailsClicked: EventEmitter<LaunchpadUser> = new EventEmitter<LaunchpadUser>();
  @Output() toggleUserActiveStatusClicked: EventEmitter<LaunchpadUser> = new EventEmitter<LaunchpadUser>();
  @Output() resendInviteClicked: EventEmitter<LaunchpadUser> = new EventEmitter<LaunchpadUser>();
  @Output() impersonateClicked: EventEmitter<LaunchpadUser> = new EventEmitter<LaunchpadUser>();
  @Output() deleteUserClicked: EventEmitter<LaunchpadUser> = new EventEmitter<LaunchpadUser>();

  protected userEmail: string = '';

  constructor(private oidcSecurityService: OidcSecurityService) { }

  ngOnInit() {
    this.getUserEmail();
  }

  get noUsersFound(): boolean {
    return !this.users || this.users.length == 0
  }

  editUser(user: LaunchpadUser) {
    this.editUserClicked.emit(user);
  }

  showDetails(user: LaunchpadUser) {
    this.detailsClicked.emit(user);
  }

  toggleUserActiveStatus(user: LaunchpadUser) {
    this.toggleUserActiveStatusClicked.emit(user);
  }

  resendInvite(user: LaunchpadUser) {
    this.resendInviteClicked.emit(user);
  }

  impersonateUser(user: LaunchpadUser) {
    this.impersonateClicked.emit(user);
  }

  deleteUser(user: LaunchpadUser) {
    this.deleteUserClicked.emit(user);
  }

  private getUserEmail(): void {
    this.oidcSecurityService.getUserData().subscribe(user => {
      this.userEmail = (user[ClaimKeys.Upn] ?? '').toLowerCase();
    });
  }
}
